import {
  buildRegisterAdminProspectPushDeviceRequest,
  buildUnregisterAdminProspectPushDeviceRequest,
  buildGetAdminProspectPushDeviceStatusRequest,
  buildResolveAdminProspectPushRefRequest,
} from './prospectWebPushRequest.js';
import {
  parseRegisterAdminProspectPushDevice,
  parseUnregisterAdminProspectPushDevice,
  parseGetAdminProspectPushDeviceStatus,
  parseResolveAdminProspectPushRef,
} from './prospectWebPushResponse.js';

export {
  buildRegisterAdminProspectPushDeviceRequest,
  buildUnregisterAdminProspectPushDeviceRequest,
  buildGetAdminProspectPushDeviceStatusRequest,
  buildResolveAdminProspectPushRefRequest,
};

export async function registerAdminProspectPushDevice(input, { httpsCallable, functions } = {}) {
  if (typeof httpsCallable !== 'function' || !functions) {
    throw new Error('push_callable_unavailable');
  }
  const request = buildRegisterAdminProspectPushDeviceRequest(input);
  const callable = httpsCallable(functions, 'registerAdminProspectPushDevice');
  const result = await callable(request);
  return parseRegisterAdminProspectPushDevice(result?.data);
}

export async function unregisterAdminProspectPushDevice(input, { httpsCallable, functions } = {}) {
  if (typeof httpsCallable !== 'function' || !functions) {
    throw new Error('push_callable_unavailable');
  }
  const request = buildUnregisterAdminProspectPushDeviceRequest(input);
  const callable = httpsCallable(functions, 'unregisterAdminProspectPushDevice');
  const result = await callable(request);
  return parseUnregisterAdminProspectPushDevice(result?.data);
}

export async function getAdminProspectPushDeviceStatus(input, { httpsCallable, functions } = {}) {
  if (typeof httpsCallable !== 'function' || !functions) {
    throw new Error('push_callable_unavailable');
  }
  const request = buildGetAdminProspectPushDeviceStatusRequest(input);
  const callable = httpsCallable(functions, 'getAdminProspectPushDeviceStatus');
  const result = await callable(request);
  return parseGetAdminProspectPushDeviceStatus(result?.data);
}

export async function resolveAdminProspectPushRef(input, { httpsCallable, functions } = {}) {
  if (typeof httpsCallable !== 'function' || !functions) {
    throw new Error('push_callable_unavailable');
  }
  const request = buildResolveAdminProspectPushRefRequest(input);
  const callable = httpsCallable(functions, 'resolveAdminProspectPushRef');
  const result = await callable(request);
  return parseResolveAdminProspectPushRef(result?.data);
}
